import getSymbolFromCurrency from 'currency-symbol-map';
const ShowCurrenciesV2 = (currency, _price, showAbbr = true) => {
  let tempCurrency = currency && currency.toUpperCase();
  let price = Number(_price);
  const options = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };
  if (price && Number(price) % 1 !== 0) {
    price = Number(price).toLocaleString('en', options);
  }
  let _final = '';
  price = price ? price.toLocaleString() : 0;
  // console.log('on v2=', tempCurrency, currency);
  switch (tempCurrency) {
    case 'GBP':
      _final = `${getSymbolFromCurrency(tempCurrency.toLowerCase())}${price}`;
      break;
    case 'EUR':
      _final = `${getSymbolFromCurrency(tempCurrency.toLowerCase())}${price}`;
      break;
    case 'MYR':
      _final = `${price}`;
      break;
    case 'IDR':
      _final = `Rp${price}`;
      break;
    case 'AED':
      _final = `Dh${price}`;
      break;
    case 'INR':
      _final = `${getSymbolFromCurrency(tempCurrency.toLowerCase())}${price}`;
      break;
    default:
      _final = `$${price}`;
      break;
  }
  return _final;
};

export default ShowCurrenciesV2;
